import { AxiosError } from 'axios';
import { atomWithQuery } from 'jotai-tanstack-query';
import { instance } from '.';
import * as _ from 'lodash';
import { selectedSiteAtom } from '@/components/verify/constants';
export const siteListAtom = atomWithQuery<any, AxiosError, any, [string]>((get) => ({
  queryKey: ['SITE_LIST'],
  queryFn: async ({ queryKey: [] }) => {
    const temp = await getSiteList();
    if (temp) {
      return _.orderBy(_.filter(temp.data.data, ['shipping', 2]), 'site_id');
    }
  },
}));

const getSiteList = async () => {
  return await instance.get('/api_m2cloud/site', { params: { account_id: 1 } });
};

export const routeListAtom = atomWithQuery<any, AxiosError, any, [string, number]>((get) => ({
  queryKey: ['ROUTE_LIST', get(selectedSiteAtom)],
  queryFn: async ({ queryKey: [, site_id] }) => {
    const temp = site_id ? await getRouteList(site_id) : undefined;
    if (temp && temp.data?.data.length > 0) {
      const groupBy = _.groupBy(temp.data.data, 'deliver_date');
      const ret: any[] = [];
      _.each(groupBy, (values, key) => {
        ret.push({ date: key, val: values });
      });
      return _.orderBy(ret, 'date');
    }
  },
}));

const getRouteList = async (site_id: number) => {
  return await instance.get('/api_shipping/shipping/list', { params: { site_id } });
};
